import React from 'react';
import loadable from '@loadable/component';

import getPageDataLoadingAPI from '../containers/pageDataLoadingAPI';
import PreviewResolverPage from '../containers/PreviewResolverPage/PreviewResolverPage';

// routeConfiguration needs to initialize containers first
// Otherwise, components will import form container eventually and
// at that point css bundling / imports will happen in wrong order.
import { NamedRedirect } from '../components';

const pageDataLoadingAPI = getPageDataLoadingAPI();

const AuthenticationPage = loadable(() => import(/* webpackChunkName: "AuthenticationPage" */ '../containers/AuthenticationPage/AuthenticationPage'));
const CheckoutPage = loadable(() => import(/* webpackChunkName: "CheckoutPage" */ '../containers/CheckoutPage/CheckoutPage'));
const CMSPage = loadable(() => import(/* webpackChunkName: "CMSPage" */ '../containers/CMSPage/CMSPage'));
const ContactDetailsPage = loadable(() => import(/* webpackChunkName: "ContactDetailsPage" */ '../containers/ContactDetailsPage/ContactDetailsPage'));
const EventListingsPage = loadable(() => import(/* webpackChunkName: "EventListingsPage" */ '../containers/EventListingsPage/EventListingsPage'));
const EditListingPage = loadable(() => import(/* webpackChunkName: "EditListingPage" */ '../containers/EditListingPage/EditListingPage'));
const EditBidsPage = loadable(() => import(/* webpackChunkName: "EditBidsPage" */ '../containers/EditBidsPage/EditBidsPage'));
const BidsPage = loadable(() => import(/* webpackChunkName: "BidsPage" */ '../containers/BidsPage/BidsPage'));
const BidsBrowsePage = loadable(() => import(/* webpackChunkName: "BidsBrowsePage" */ '../containers/BidsBrowsePage/BidsBrowsePage'));
const EmailVerificationPage = loadable(() => import(/* webpackChunkName: "EmailVerificationPage" */ '../containers/EmailVerificationPage/EmailVerificationPage'));
const InboxPage = loadable(() => import(/* webpackChunkName: "InboxPage" */ '../containers/InboxPage/InboxPage'));
const LandingPage = loadable(() => import(/* webpackChunkName: "LandingPage" */ '../containers/LandingPage/LandingPage'));
const AboutPage = loadable(() => import(/* webpackChunkName: "AboutPage" */ '../containers/AboutPage/AboutPage'));
const ListingPageCoverPhoto = loadable(() => import(/* webpackChunkName: "ListingPageCoverPhoto" */ /* webpackPrefetch: true */ '../containers/ListingPage/ListingPageCoverPhoto'));
const ListingPageCarousel = loadable(() => import(/* webpackChunkName: "ListingPageCarousel" */ /* webpackPrefetch: true */ '../containers/ListingPage/ListingPageCarousel'));
const ManageListingsPage = loadable(() => import(/* webpackChunkName: "ManageListingsPage" */ '../containers/ManageListingsPage/ManageListingsPage'));
const PasswordChangePage = loadable(() => import(/* webpackChunkName: "PasswordChangePage" */ '../containers/PasswordChangePage/PasswordChangePage'));
const PasswordRecoveryPage = loadable(() => import(/* webpackChunkName: "PasswordRecoveryPage" */ '../containers/PasswordRecoveryPage/PasswordRecoveryPage'));
const PasswordResetPage = loadable(() => import(/* webpackChunkName: "PasswordResetPage" */ '../containers/PasswordResetPage/PasswordResetPage'));
const PaymentMethodsPage = loadable(() => import(/* webpackChunkName: "PaymentMethodsPage" */ '../containers/PaymentMethodsPage/PaymentMethodsPage'));
const PrivacyPolicyPage = loadable(() => import(/* webpackChunkName: "PrivacyPolicyPage" */ '../containers/PrivacyPolicyPage/PrivacyPolicyPage'));
const ProfilePage = loadable(() => import(/* webpackChunkName: "ProfilePage" */ '../containers/ProfilePage/ProfilePage'));
const ProfileSettingsPage = loadable(() => import(/* webpackChunkName: "ProfileSettingsPage" */ '../containers/ProfileSettingsPage/ProfileSettingsPage'));
const ProfileSetupPage = loadable(() => import(/* webpackChunkName: "ProfileSetupPage" */ '../containers/ProfileSetupPage/ProfileSetupPage'));
const VibesPage = loadable(() => import(/* webpackChunkName: "VibesPage" */ '../containers/VibesPage/VibesPage'));
const CrewsPage = loadable(() => import(/* webpackChunkName: "CrewsPage" */ '../containers/CrewsPage/CrewsPage'));
const CrewsSelectionPage = loadable(() => import(/* webpackChunkName: "CrewsSelectionPage" */ '../containers/CrewsSelectionPage/CrewsSelectionPage'));
const FindCrewsPage = loadable(() => import(/* webpackChunkName: "FindCrewsPage" */ '../containers/FindCrewsPage/FindCrewsPage'));
const FindLinkUpsPage = loadable(() => import(/* webpackChunkName: "FindLinkUpsPage" */ '../containers/FindLinkUpsPage/FindLinkUpsPage'));
const MyCrewsPage = loadable(() => import(/* webpackChunkName: "MyCrewsPage" */ '../containers/MyCrewsPage/MyCrewsPage'));
const LinkUpChatPage = loadable(() => import(/* webpackChunkName: "LinkUpChatPage" */ '../containers/LinkUpChatPage/LinkUpChatPage'));
const CreateCrewPage = loadable(() => import(/* webpackChunkName: "CreateCrewPage" */ '../containers/CreateCrewPage/CreateCrewPage'));
const CreateLinkUpPage = loadable(() => import(/* webpackChunkName: "CreateLinkUpPage" */ '../containers/CreateLinkUpPage/CreateLinkUpPage'));
const CreatePostPage = loadable(() => import(/* webpackChunkName: "CreatePostPage" */ '../containers/CreatePostPage/CreatePostPage'));
const AccountSettingsPage = loadable(() => import(/* webpackChunkName: "AccountSettingsPage" */ '../containers/AccountSettingsPage/AccountSettingsPage'));
const CreateBidPage = loadable(() => import(/* webpackChunkName: "CreateBidPage" */ '../containers/CreateBidPage/CreateBidPage'));
const MyActivityPage = loadable(() => import(/* webpackChunkName: "MyActivityPage" */ '../containers/MyActivityPage/MyActivityPage'));
const UserSettingsPage = loadable(() => import(/* webpackChunkName: "UserSettingsPage" */ '../containers/UserSettingsPage/UserSettingsPage'));
const CrewPostPage = loadable(() => import(/* webpackChunkName: "CrewPostPage" */ '../containers/CrewPostPage/CrewPostPage'));
const SubmitOfferPage = loadable(() => import(/* webpackChunkName: "SubmitOfferPage" */ '../containers/SubmitOfferPage/SubmitOfferPage'));
const CrewPage = loadable(() => import(/* webpackChunkName: "CrewPage" */ '../containers/CrewPage/CrewPage'));
const EventComingSoonPage = loadable(() => import(/* webpackChunkName: "EventComingSoonPage" */ '../containers/EventComingSoonPage/EventComingSoonPage'));
const SearchPageWithMap = loadable(() => import(/* webpackChunkName: "SearchPageWithMap" */ /* webpackPrefetch: true */  '../containers/SearchPage/SearchPageWithMap'));
const SearchPageWithGrid = loadable(() => import(/* webpackChunkName: "SearchPageWithGrid" */ /* webpackPrefetch: true */  '../containers/SearchPage/SearchPageWithGrid'));
const StripePayoutPage = loadable(() => import(/* webpackChunkName: "StripePayoutPage" */ '../containers/StripePayoutPage/StripePayoutPage'));
const TermsOfServicePage = loadable(() => import(/* webpackChunkName: "TermsOfServicePage" */ '../containers/TermsOfServicePage/TermsOfServicePage'));
const TicketListingsPage = loadable(() => import(/* webpackChunkName: "TicketListingsPage" */ '../containers/TicketListingsPage/TicketListingsPage'));
const TicketBidsPage = loadable(() => import(/* webpackChunkName: "TicketBidsPage" */ '../containers/TicketBidsPage/TicketBidsPage'));
const TransactionPage = loadable(() => import(/* webpackChunkName: "TransactionPage" */ '../containers/TransactionPage/TransactionPage'));
const NoAccessPage = loadable(() => import(/* webpackChunkName: "NoAccessPage" */ '../containers/NoAccessPage/NoAccessPage'));
const NotFoundPage = loadable(() => import(/* webpackChunkName: "NotFoundPage" */ '../containers/NotFoundPage/NotFoundPage'));

// Styleguide removed for production

export const ACCOUNT_SETTINGS_PAGES = [
  'ContactDetailsPage',
  'PasswordChangePage',
  'StripePayoutPage',
  'PaymentMethodsPage',
];

// https://en.wikipedia.org/wiki/Universally_unique_identifier#Nil_UUID
const draftId = '00000000-0000-0000-0000-000000000000';
const draftSlug = 'draft';

const RedirectToLandingPage = () => <NamedRedirect name="LandingPage" />;

// NOTE: Most server-side endpoints are prefixed with /api. Requests to those
// endpoints are indended to be handled in the server instead of the browser and
// they will not render the application. So remember to avoid routes starting
// with /api and if you encounter clashing routes see server/index.js if there's
// a conflicting route defined there.

// Our routes are exact by default.
// See behaviour from Routes.js where Route is created.
const routeConfiguration = (layoutConfig, accessControlConfig) => {
  const SearchPage = layoutConfig.searchPage?.variantType === 'map' 
    ? SearchPageWithMap 
    : SearchPageWithGrid;
  const ListingPage = layoutConfig.listingPage?.variantType === 'carousel' 
    ? ListingPageCarousel 
    : ListingPageCoverPhoto;

  const isPrivateMarketplace = accessControlConfig?.marketplace?.private === true;
  const authForPrivateMarketplace = isPrivateMarketplace ? { auth: true } : {};
  
  return [
    {
      path: '/',
      name: 'LandingPage',
      component: LandingPage,
      loadData: pageDataLoadingAPI.LandingPage.loadData,
    },
    {
      path: '/p/:pageId',
      name: 'CMSPage',
      component: CMSPage,
      loadData: pageDataLoadingAPI.CMSPage.loadData,
    },
    {
      path: '/about',
      name: 'AboutPage',
      component: AboutPage,
      loadData: pageDataLoadingAPI.AboutPage.loadData,
    },
    // NOTE: when the private marketplace feature is enabled, the '/s' route is disallowed by the robots.txt resource.
    // If you add new routes that start with '/s*' (e.g. /support), you should add them to the robotsPrivateMarketplace.txt file.
    {
      path: '/s',
      name: 'SearchPageRedirect',
      component: RedirectToLandingPage,
    },
    {
      path: '/events',
      name: 'EventListingsPage',
      ...authForPrivateMarketplace,
      component: EventListingsPage,
      loadData: pageDataLoadingAPI.SearchPage.loadData, // Reuse SearchPage loadData
    },
    {
      path: '/tickets',
      name: 'TicketListingsPage',
      ...authForPrivateMarketplace,
      component: TicketListingsPage,
    },
    {
      path: '/ticket-bids',
      name: 'TicketBidsPage',
      ...authForPrivateMarketplace,
      component: TicketBidsPage,
    },
    {
      path: '/profile-setup',
      name: 'ProfileSetupPage',
      auth: true,
      component: ProfileSetupPage,
    },
    {
      path: '/vibes',
      name: 'VibesPage',
      auth: true,
      component: VibesPage,
    },
    {
      path: '/crews',
      name: 'CrewsPage',
      auth: true,
      component: CrewsPage,
      loadData: pageDataLoadingAPI.CrewsPage.loadData,
    },
    {
      path: '/crews-selection',
      name: 'CrewsSelectionPage',
      auth: true,
      component: CrewsSelectionPage,
    },
    {
      path: '/find-crews',
      name: 'FindCrewsPage',
      auth: true,
      component: FindCrewsPage,
      loadData: pageDataLoadingAPI.FindCrewsPage.loadData,
    },
    {
      path: '/find-linkups',
      name: 'FindLinkUpsPage',
      auth: true,
      component: FindLinkUpsPage,
      loadData: pageDataLoadingAPI.FindLinkUpsPage.loadData,
    },
    {
      path: '/my-crews',
      name: 'MyCrewsPage',
      auth: true,
      component: MyCrewsPage,
    },
    {
      path: '/linkup-chat/:linkUpId',
      name: 'LinkUpChatPage',
      auth: true,
      component: LinkUpChatPage,
      loadData: pageDataLoadingAPI.LinkUpChatPage.loadData,
    },
    {
      path: '/linkup-chat',
      name: 'LinkUpChatPageEmpty',
      auth: true,
      component: LinkUpChatPage,
      loadData: pageDataLoadingAPI.LinkUpChatPage.loadData,
    },
      {
    path: '/create-crew',
    name: 'CreateCrewPage',
    auth: true,
    component: CreateCrewPage,
  },
  {
    path: '/create-linkup',
    name: 'CreateLinkUpPage',
    auth: true,
    component: CreateLinkUpPage,
  },
  {
    path: '/create-post',
    name: 'CreatePostPage',
    auth: true,
    component: CreatePostPage,
  },
  {
    path: '/crew-post/:postId',
    name: 'CrewPostPage',
    auth: true,
    component: CrewPostPage,
  },
  {
    path: '/account-settings',
    name: 'AccountSettingsPage',
    auth: true,
    component: props => <NamedRedirect name="UserSettingsPage" params={{ section: 'account' }} />,
  },
  {
    path: '/my-activity',
    name: 'MyActivityPage',
    auth: true,
    component: MyActivityPage,
  },
  {
    path: '/user-settings',
    name: 'UserSettingsPage',
    auth: true,
    component: UserSettingsPage,
  },
    {
      path: '/crew/:crewname',
      name: 'CrewPage',
      auth: true,
      component: CrewPage,
    },
    {
      path: '/event/:eventSlug',
      name: 'EventComingSoonPage',
      component: EventComingSoonPage,
    },
    {
      path: '/l',
      name: 'ListingBasePage',
      component: RedirectToLandingPage,
    },
    {
      path: '/l/:slug/:id',
      name: 'ListingPage',
      ...authForPrivateMarketplace,
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/l/:slug/:id/checkout',
      name: 'CheckoutPage',
      auth: true,
      component: CheckoutPage,
      setInitialValues: pageDataLoadingAPI.CheckoutPage.setInitialValues,
    },
    {
      path: '/l/:slug/:id/submit-offer',
      name: 'SubmitOfferPage',
      auth: true,
      component: SubmitOfferPage,
      loadData: pageDataLoadingAPI.SubmitOfferPage.loadData,
    },
    {
      path: '/l/:slug/:id/:variant',
      name: 'ListingPageVariant',
      auth: true,
      authPage: 'LoginPage',
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/l/new',
      name: 'NewListingPage',
      auth: true,
      component: () => {
        const { LISTING_TYPES } = require('../util/listingTypes');
        return (
          <NamedRedirect
            name="EditListingPage"
            params={{ slug: draftSlug, id: draftId, type: 'new', tab: 'details' }}
            search={`?listingType=${LISTING_TYPES.TICKET_SALE}`}
          />
        );
      },
    },
    {
      path: '/l/:slug/:id/:type/:tab',
      name: 'EditListingPage',
      auth: true,
      component: EditListingPage,
      loadData: pageDataLoadingAPI.EditListingPage.loadData,
    },
    {
      path: '/l/:slug/:id/:type/:tab/:returnURLType',
      name: 'EditListingStripeOnboardingPage',
      auth: true,
      component: EditListingPage,
      loadData: pageDataLoadingAPI.EditListingPage.loadData,
    },

    // BidsPage routes - Using Sharetribe listings with original UI
    {
      path: '/bids',
      name: 'BidsPage',
      auth: false, // Can be public to browse requests
      component: BidsBrowsePage, // Uses Sharetribe listings but keeps original UI
      loadData: pageDataLoadingAPI.BidsBrowsePage?.loadData,
    },
    {
      path: '/bids/new',
      name: 'NewBidsPage',
      auth: true,
      component: () => {
        // Redirect to EditListingPage with listing type parameter
        // Uses 'testing-bids' listing type configured in Sharetribe Console (Reverse Price Negotiation)
        const { LISTING_TYPES } = require('../util/listingTypes');
        const { stringify } = require('../util/urlHelpers');
        const listingTypeId = LISTING_TYPES.TICKET_REQUEST; // 'testing-bids'
        const searchQuery = stringify({ listingType: listingTypeId });
        return (
          <NamedRedirect
            name="EditListingPage"
            params={{ 
              slug: 'draft', 
              id: '00000000-0000-0000-0000-000000000000', 
              type: 'new', 
              tab: 'details'
            }}
            search={searchQuery}
          />
        );
      },
    },
    // Keep EditBidsPage route for backward compatibility during migration
    {
      path: '/bids/:slug/:id/:type/:tab',
      name: 'EditBidsPage',
      auth: true,
      component: EditBidsPage,
    },

    // Canonical path should be after the `/l/new` path since they
    // conflict and `new` is not a valid listing UUID.
    {
      path: '/l/:id',
      name: 'ListingPageCanonical',
      ...authForPrivateMarketplace,
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/u',
      name: 'ProfileBasePage',
      component: RedirectToLandingPage,
    },
    {
      path: '/u/:id',
      name: 'ProfilePage',
      ...authForPrivateMarketplace,
      component: ProfilePage,
      loadData: pageDataLoadingAPI.ProfilePage.loadData,
    },
    {
      path: '/u/:id/:variant',
      name: 'ProfilePageVariant',
      auth: true,
      component: ProfilePage,
      loadData: pageDataLoadingAPI.ProfilePage.loadData,
    },
    {
      path: '/profile-settings',
      name: 'ProfileSettingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: props => <NamedRedirect name="UserSettingsPage" />,
    },

    // Note: authenticating with IdP (e.g. Facebook) expects that /login path exists
    // so that in the error case users can be redirected back to the LoginPage
    // In case you change this, remember to update the route in server/api/auth/loginWithIdp.js
    {
      path: '/login',
      name: 'LoginPage',
      component: AuthenticationPage,
      extraProps: { tab: 'login' },
      loadData: pageDataLoadingAPI.AuthenticationPage.loadData,
    },
    {
      path: '/signup',
      name: 'SignupPage',
      component: AuthenticationPage,
      extraProps: { tab: 'signup' },
      loadData: pageDataLoadingAPI.AuthenticationPage.loadData,
    },
    {
      path: '/signup/:userType',
      name: 'SignupForUserTypePage',
      component: AuthenticationPage,
      extraProps: { tab: 'signup' },
      loadData: pageDataLoadingAPI.AuthenticationPage.loadData,
    },
    {
      path: '/confirm',
      name: 'ConfirmPage',
      component: AuthenticationPage,
      extraProps: { tab: 'confirm' },
      loadData: pageDataLoadingAPI.AuthenticationPage.loadData,
    },
    {
      path: '/recover-password',
      name: 'PasswordRecoveryPage',
      component: PasswordRecoveryPage,
    },
    {
      path: '/inbox',
      name: 'InboxBasePage',
      auth: true,
      authPage: 'LoginPage',
      component: () => <NamedRedirect name="InboxPage" params={{ tab: 'sales' }} />,
    },
    {
      path: '/inbox/:tab',
      name: 'InboxPage',
      auth: true,
      authPage: 'LoginPage',
      component: InboxPage,
      loadData: pageDataLoadingAPI.InboxPage.loadData,
    },
    {
      path: '/order/:id',
      name: 'OrderDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: TransactionPage,
      extraProps: { transactionRole: 'customer' },
      loadData: (params, ...rest) =>
        pageDataLoadingAPI.TransactionPage.loadData({ ...params, transactionRole: 'customer' }, ...rest),
      setInitialValues: pageDataLoadingAPI.TransactionPage.setInitialValues,
    },
    {
      path: '/order/:id/details',
      name: 'OrderDetailsPageRedirect',
      auth: true,
      authPage: 'LoginPage',
      component: props => <NamedRedirect name="OrderDetailsPage" params={{ id: props.params?.id }} />,
    },
    {
      path: '/sale/:id',
      name: 'SaleDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: TransactionPage,
      extraProps: { transactionRole: 'provider' },
      loadData: pageDataLoadingAPI.TransactionPage.loadData,
    },
    {
      path: '/sale/:id/details',
      name: 'SaleDetailsPageRedirect',
      auth: true,
      authPage: 'LoginPage',
      component: props => <NamedRedirect name="SaleDetailsPage" params={{ id: props.params?.id }} />,
    },
    {
      path: '/listings',
      name: 'ManageListingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ManageListingsPage,
      loadData: pageDataLoadingAPI.ManageListingsPage.loadData,
    },
    {
      path: '/account',
      name: 'AccountSettingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: () => <NamedRedirect name="ContactDetailsPage" />,
    },
    {
      path: '/account/contact-details',
      name: 'ContactDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ContactDetailsPage,
      loadData: pageDataLoadingAPI.ContactDetailsPage.loadData,
    },
    {
      path: '/account/change-password',
      name: 'PasswordChangePage',
      auth: true,
      authPage: 'LoginPage',
      component: PasswordChangePage,
    },
    {
      path: '/account/payments',
      name: 'StripePayoutPage',
      auth: true,
      authPage: 'LoginPage',
      component: StripePayoutPage,
      loadData: pageDataLoadingAPI.StripePayoutPage.loadData,
    },
    {
      path: '/account/payments/:returnURLType',
      name: 'StripePayoutOnboardingPage',
      auth: true,
      authPage: 'LoginPage',
      component: StripePayoutPage,
      loadData: pageDataLoadingAPI.StripePayoutPage.loadData,
    },
    {
      path: '/account/payment-methods',
      name: 'PaymentMethodsPage',
      auth: true,
      authPage: 'LoginPage',
      component: PaymentMethodsPage,
      loadData: pageDataLoadingAPI.PaymentMethodsPage.loadData,
    },
    {
      path: '/terms-of-service',
      name: 'TermsOfServicePage',
      component: TermsOfServicePage,
      loadData: pageDataLoadingAPI.TermsOfServicePage.loadData,
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicyPage',
      component: PrivacyPolicyPage,
      loadData: pageDataLoadingAPI.PrivacyPolicyPage.loadData,
    },
    // Styleguide routes removed for production
    {
      path: '/no-:missingAccessRight',
      name: 'NoAccessPage',
      component: NoAccessPage,
    },
    {
      path: '/notfound',
      name: 'NotFoundPage',
      component: NotFoundPage,
    },

    // Do not change this path!
    //
    // The API expects that the application implements /reset-password endpoint
    {
      path: '/reset-password',
      name: 'PasswordResetPage',
      component: PasswordResetPage ,
    },

    // Do not change this path!
    //
    // The API expects that the application implements /verify-email endpoint
    {
      path: '/verify-email',
      name: 'EmailVerificationPage',
      auth: true,
      authPage: 'LoginPage',
      component: EmailVerificationPage,
      loadData: pageDataLoadingAPI.EmailVerificationPage.loadData,
    },
    // Do not change this path!
    //
    // The API expects that the application implements /preview endpoint
    {
      path: '/preview',
      name: 'PreviewResolverPage',
      component: PreviewResolverPage ,
    },
    // NOTE: The catch-all for unmatched URLs is handled in Routes.js via the
    // <Switch> fallback (it renders NotFoundPage). We intentionally do NOT add a
    // `path: '*'` route here: path-to-regexp v8 (used by toPathByRouteName/compile)
    // cannot compile a bare '*', so any link resolving to it would throw
    // "Missing parameter name". See src/routing/Routes.js.
  ];
};

export default routeConfiguration;
